<script lang="ts">
    import { submitStatus, SUBMIT_STATUS } from "./data.ts";
</script>

{#if $submitStatus === SUBMIT_STATUS.SUBMITTING}
  Versturen...
{:else if $submitStatus === SUBMIT_STATUS.SUCCESS}
  Bedankt!
{:else if $submitStatus === SUBMIT_STATUS.ERROR}
  Er is helaas iets mis gegaan met versturen.
{/if}